export const ADMIN_ROLES = ['Admin', 'Super Admin'];

export const STAFF_ROLES = [
  'Fee Entry',
  'Billing Viewer',
  'Receiving Clerk',
  'Fulfillment Staff',
  'Warehouse Staff',
];

export const selectUser = (state) => state.user;
export const selectUserRole = (state) => state.user.role;
export const selectIsAuthenticated = (state) => state.user.isAuthenticated;
export const selectIsAdmin = (state) => ADMIN_ROLES.includes(state.user.role);
export const selectIsStaff = (state) => STAFF_ROLES.includes(state.user.role);
export const selectIsClient = (state) => state.user.role === 'client';
export const selectViewMode = (state) =>
  state.user.role === 'Super Admin' ? (state.user.viewMode ?? 'super_admin') : 'super_admin';
